import { routes } from '@shared/constants/routes'
import { resetAnalytics, USER_TRAITS_SESSION_STORAGE } from '@/features/shared/analytics/utils'
import { clear, getItem, setItem } from '@/features/shared/utils/localStorage'
import { isOnServer } from '@shared/constants/util'
import { getQueryClient } from '@/features/shared/utils/dataFetching/reactQuery/SegwayQueryClient'
import { type LogoutOptions } from '@/features/authentication/utils/authentication/client'
import { datadogRum } from '@datadog/browser-rum'
import { removeSessionStorageItem } from '@/features/shared/utils/sessionStorage'
import { TRANSCEND_CONSENT_LS_KEY } from '@shared/constants/transcend'
import { GIFT_ORDER_SESSION_STORAGE } from '@/features/purchase/state/GiftOrder/constants'
import { SMS_ENTRY_POINT_STORAGE } from '@/features/shared/components/HamburgerMenu/constants'
import { isSafeSegwayURL } from '@/features/shared/utils/url'
import { logError } from '@/features/shared/utils/logger'
import { SHOP_SESSION_FLAGS_SESSION_STORAGE } from '@/features/shop/state/ShopSessionFlags/constants'
import { AI_CART_BUILDER_SESSION_STORAGE } from '@/features/shop/state/AICartBuilder/constants'
import { clearCachedAuthData } from '@/features/authentication/utils/authentication/client/auth0/service'
import { removeSelectedUserGroupIdCookie } from '@/features/business/utils/selectedUserGroupCookie'
import { VIDEO_BANNER_DISMISSED_SESSION_STORAGE } from '@/features/cms/components/CMS/components/VideoBanner/constants'
import { onlineManager } from '@tanstack/react-query'

export const SESSION_STORAGE_KEYS_TO_CLEAR = [
  USER_TRAITS_SESSION_STORAGE,
  SMS_ENTRY_POINT_STORAGE,
  GIFT_ORDER_SESSION_STORAGE,
  SHOP_SESSION_FLAGS_SESSION_STORAGE,
  AI_CART_BUILDER_SESSION_STORAGE,
  VIDEO_BANNER_DISMISSED_SESSION_STORAGE,
]

export const resetUser = ({ redirectUrl = routes.LOGOUT.url }: LogoutOptions = {}) => {
  if (isOnServer()) return

  // disable all queries by setting online status to false since we don't allow offline mode anyway.
  onlineManager.setOnline(false)

  const queryClient = getQueryClient()
  queryClient.cancelQueries()

  removeSelectedUserGroupIdCookie()
  resetAnalytics()
  clearCachedAuthData()

  // we need to persist the tcmConsent key in localStorage for transcend purposes before clearing the rest
  const tcmConsent = getItem(TRANSCEND_CONSENT_LS_KEY)
  clear()
  if (tcmConsent) setItem(TRANSCEND_CONSENT_LS_KEY, tcmConsent)
  SESSION_STORAGE_KEYS_TO_CLEAR.forEach((key) => removeSessionStorageItem(key))
  // stop datadog session. Any new event will create a new session and useMonitorUser will overwrite any
  // user properties when it reruns
  datadogRum.stopSession()

  if (isSafeSegwayURL(redirectUrl)) {
    window.location.href = redirectUrl
  } else {
    logError(`unsafe redirect URL detected: ${redirectUrl}`)
    window.location.href = routes.LOGOUT.url
  }
}
